require('./voiceReader.scss');

const PropTypes = require('prop-types');

const React = require('react');
const {Component} = require('react');
const {connect} = require('react-redux');
const { cleanReader } = require('actions/voiceReader');
const { bindActionCreators } = require('redux');
const get = require('lodash/object/get');

class VoiceReader extends Component {

    componentDidUpdate() {
        const { timeToRead } = this.props;
        // Jero: We need to clean the message in order to allow repeat the same text twice or more times.
        // And we need wait some time before clean live region in order to allow the SR can reader it before
        // we clean it.
        setTimeout(() => {
            this.props.cleanReader();
        }, timeToRead)
    }

    render() {
        const immVoiceContent = get(this.props, 'voiceReader');
        const textLiveRegion = immVoiceContent.get('voiceReader');
        return (
            <p  aria-live="assertive"
                aria-atomic="true"
                aria-relevant="additions"
                className="aria-live voice-reader"
            >
                {textLiveRegion}
            </p>);
    }
}

VoiceReader.propTypes = {
    voiceReader: PropTypes.object,
    cleanReader: PropTypes.func,
    timeToRead: PropTypes.number
};

VoiceReader.defaultProps = {
    timeToRead: 2000
};

module.exports.constructor = VoiceReader;
module.exports.VoiceReader = connect(
        state => ({
        voiceReader: state.voiceReader
    }),
        dispatch => ({
        cleanReader: bindActionCreators(cleanReader, dispatch)
    })
)(VoiceReader);